export default "__VITE_ASSET__Dmi4XsKI__"